import React, { useState, useEffect } from 'react';
import { useRatingScaleService, DEFAULT_RATING_SCALE } from '../api/RatingScaleService';

const ManagerRatingInput = ({ value, onChange, disabled, label = "Manager's Rating", orgUnitId }) => {
  const { loadRatingScale } = useRatingScaleService(orgUnitId);
  const [ratingScale, setRatingScale] = useState(DEFAULT_RATING_SCALE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (orgUnitId) {
      loadRatingScale().then(scale => {
        if (scale && Array.isArray(scale)) {
          setRatingScale(scale);
        } else {
          setRatingScale(DEFAULT_RATING_SCALE);
        }
        setLoading(false);
      }).catch(() => {
        setRatingScale(DEFAULT_RATING_SCALE);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [orgUnitId]);

  const getRatingColor = (val) => {
    if (!ratingScale || !Array.isArray(ratingScale)) return '#6c757d';
    const rating = ratingScale.find(r => r && r.value === val);
    return rating ? rating.color : '#6c757d';
  };

  const getRatingLabel = (val) => {
    if (!ratingScale || !Array.isArray(ratingScale)) return `${val} - Unknown`;
    const rating = ratingScale.find(r => r && r.value === val);
    return rating ? rating.label : `${val} - Unknown`;
  };

  if (loading) {
    return <div>Loading rating options...</div>;
  }

  if (!ratingScale || !Array.isArray(ratingScale) || ratingScale.length === 0) {
    return <div>No rating scale configured for this organisation</div>;
  }

  return (
    <div style={{ marginBottom: '12px' }}>
      <div style={{ fontWeight: 500, marginBottom: '8px', fontSize: '0.9rem' }}>
        {label}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '8px' }}>
        {ratingScale.map(rating => (
          <button
            key={rating.value}
            type="button"
            onClick={() => !disabled && onChange(rating.value)}
            disabled={disabled}
            style={{
              padding: '8px 12px',
              borderRadius: '8px',
              border: value === rating.value ? `2px solid ${rating.color}` : '1px solid #ddd',
              backgroundColor: value === rating.value ? `${rating.color}20` : '#f8f9fa',
              color: value === rating.value ? rating.color : '#666',
              fontWeight: value === rating.value ? 'bold' : 'normal',
              cursor: disabled ? 'not-allowed' : 'pointer',
              fontSize: '0.85rem',
              textAlign: 'center',
              transition: 'all 0.2s'
            }}
            title={rating.description}
          >
            {rating.label}
          </button>
        ))}
      </div>
      {value && ratingScale && (
        <div style={{ 
          marginTop: '8px', 
          fontSize: '0.8rem', 
          color: getRatingColor(value),
          fontStyle: 'italic',
          padding: '4px 8px',
          backgroundColor: `${getRatingColor(value)}20`,
          borderRadius: '4px'
        }}>
          {getRatingLabel(value)} - {ratingScale.find(r => r && r.value === value)?.description}
        </div>
      )}
    </div>
  );
};

export default ManagerRatingInput;